'use strict';
var SupportForYourPracticeService = /** @class */ (function () {
    /*@ngInject*/
    function SupportForYourPracticeService($http) {
        this._$http = $http;
    }
    /*@ngInject*/
    SupportForYourPracticeService.prototype.getContent = function (id) {
        var request = this._$http({
            method: "get",
            url: "api/content/" + id
        });
        return request.then(function (data) {
            return data;
        }, function () {
            return {};
        });
    };
    /*@ngInject*/
    SupportForYourPracticeService.prototype.getWellevate = function () {
        return this.getContent(9007);
    };
    /*@ngInject*/
    SupportForYourPracticeService.prototype.getEducation = function () {
        return this.getContent(9029);
    };
    /*@ngInject*/
    SupportForYourPracticeService.prototype.getQuality = function () {
        return this.getContent(9008);
    };
    return SupportForYourPracticeService;
}());
export default SupportForYourPracticeService;
//# sourceMappingURL=supportforyourpractice.service.js.map